<template>
  <dv-border-box-12 class="video" backgroundColor="rgba(8, 50, 78, 0.6)">
    <PartTitle title="视频监控" :hasLink="true" linkText="工厂监控" @onLinkClick="openPopup" />
    <div class="video-box">
      <iframe
        :src="baseVideoUrl"
        frameborder="0"
        allow="fullscreen; autoplay; encrypted-media"
        allowfullscreen
        width="100%"
        height="100%">
      </iframe>
    </div>

    <!-- 弹出 工厂监控 -->
    <div class="video-popup" v-if="popupShow">
      <dv-border-box-8 class="box" backgroundColor="rgba(8, 50, 78, 0.8)" :dur="6">
        <PartTitle title="工厂/基地监控" style="width: 98%; height: 60px" :hasSuffix="false" />
        <div class="close" @click="closePopup">
          <span>X</span>
        </div>
        <div class="v-wrap">
          <iframe
            ref="refFactoryVideo"
            :src="factoryVideoUrl"
            frameborder="0"
            allow="fullscreen; autoplay; encrypted-media"
            allowfullscreen
            width="100%"
            height="100%">
          </iframe>
        </div>
      </dv-border-box-8>
    </div>
  </dv-border-box-12>
</template>

<script>
import PartTitle from './PartTitle.vue';

export default {
  name: 'VideoLive',
  components: { PartTitle },
  props: {
    videoData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      baseVideoUrl: '',
      factoryVideoUrl: '',
      popupShow: false,
    };
  },

  watch: {
    videoData: {
      handler(val) {
        this.baseVideoUrl = val?.baseVideoUrl;
        this.factoryVideoUrl = val?.factoryVideoUrl;
      },
      immediate: true,
      deep: true,
    },
  },

  created() {},
  mounted() {
    const refVideo = this.$refs['refFactoryVideo'];
    if (refVideo) {
      if (refVideo.requestFullScreen) {
        refVideo.requestFullScreen();
      } else if (refVideo.mozRequestFullScreen) {
        refVideo.mozRequestFullScreen();
      } else if (refVideo.webkitRequestFullScreen) {
        refVideo.webkitRequestFullScreen();
      }
    }
  },
  methods: {
    goFactoryVideoPage() {
      window.open(this.factoryVideoUrl, '_blank');
    },

    openPopup() {
      this.popupShow = true;
    },
    closePopup() {
      this.popupShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.video {
  flex: 1;
}

.video-box {
  width: calc(100% - 18px);
  height: calc(100% - 58px);
  margin: 0 auto;
}

.video-popup {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;

  .box {
    width: 1275px;
    height: 720px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -35%;
    margin-top: -20%;

    .close {
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      justify-content: center;
      align-items: center;
      z-index: 3;
      width: 60px;
      height: 60px;
      cursor: pointer;
      span {
        font-size: 28px;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .v-wrap {
      width: 98%;
      height: calc(100% - 60px);
      margin: 0 auto;
    }
  }
}
</style>
